import React from "react";
import { connect } from 'react-redux';
import FeatureLayout from "../../basic/FeatureLayout";
import { handleFeaturesSwitch } from "../../basic/appsIncluded/components/features/helpers/featuresActions";
import styles from './Subscriptions.module.scss'
import { CardItem } from "../../../../components/card/Card";
import CardAdvanced from "../../../../components/card/CardAdvanced";

function Subscriptions({bodyStack, features, currentPlan, custom, dependencies}) {

    const subs = [...features].filter(f => f.type === 'subscriptions' || f.category?.[0]?.name === 'subscriptions');
    const warnings = [];

    if (!!bodyStack?.subscriptions?.length && !currentPlan?.supportedFeatures?.includes('subscriptions')) {
        warnings.push({
            message: 'Selected subscriptions require plan upgrade. You can purchase it later.',
            type: 'info',
            container: 'subscriptions',
            target: 'subscriptions'
        });
    }

    return (
        <CardAdvanced
            style={{marginBottom: '10px'}}
            title='Server Health & Security'
            id='subscriptions'
            messages={warnings}
            showMessages
        >
            <div className={styles['subscriptions']}>
                <div className={styles['subscriptions__content']} id='subscriptions-anchor'>
                    {
                        !subs?.length
                            ? <p className={styles['deploy-package__container__item__container__content__empty']}>
                                Not supported
                            </p>
                            : subs.map((sub, index) => {

                                // const cardContext = useContext(CardContext);

                                return (
                                    <CardItem key={index}>
                                        <FeatureLayout
                                            feature={sub}
                                            plan={currentPlan}
                                            enabled={!!bodyStack[sub.type || sub.category?.[0]?.name].some(f => (f === sub['code']))}
                                            onChange={feature => handleFeaturesSwitch([feature], custom)}
                                            // calcHeight={() => cardContext.calculateHeight()}
                                        />
                                    </CardItem>
                                )
                            })
                    }
                </div>
            </div>
        </CardAdvanced>
    )
}


let mapStateToProps = state => ({
    subscriptions: state.commonData.subscriptions,
    currentApp: state.deployment.currentApp,
    bodyStack: state.deployment.bodyStack,
    features: state.deployment.featuresData.features,
    dependencies: state.deployment.featuresData.dependencies,
    currentPlan: state.userData.currentPlan,
});

export default connect(mapStateToProps)(Subscriptions)